import {theme} from "../../utils/theme";
import styled, {css} from 'styled-components';

export const Title = styled.h2`
  color: ${theme.colors.darkText};
  font-size: 1.3em;
  font-weight: 600;
  margin-bottom: ${theme.spacing(0.5)};
`;

export const Subtext = styled.p`
  color: ${theme.colors.darkText};
  font-size: 0.85em;
  margin-bottom: ${theme.spacing(2)};
`;

export const Label = styled.label`
  display: block;
  text-align: left;
  color: ${theme.colors.darkText};
  font-weight: 500;
  font-size: 0.8em;
  margin-bottom: ${theme.spacing(1)};
  margin-top: ${theme.spacing(2)};
`;

// --- Input and Button ---

const inputStyles = css`
  width: 100%;
  padding: ${theme.spacing(1.5)};
  border: 1px solid ${theme.colors.lightGrey};
  border-radius: 4px;
  font-size: 0.9em;
  box-sizing: border-box; /* Ensures padding doesn't increase total width */
  
  &:focus {
    border-color: ${theme.colors.primary};
    outline: none;
    box-shadow: 0 0 0 2px rgba(71, 149, 119, 0.2);
  }
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const Input = styled.input`
  ${inputStyles}
`;

export const PasswordInput = styled.input`
  ${inputStyles}
  padding-right: ${theme.spacing(6)}; /* Make space for the icon */
`;

export const IconPlaceholder = styled.span`
  position: absolute;
  right: ${theme.spacing(2)};
  color: ${theme.colors.lightGrey};
  cursor: pointer;
  /* You would replace this with an actual SVG icon library like react-icons */
`;

export const Button = styled.button`
  width: 100%;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  padding: ${theme.spacing(1.5)} 0;
  border: none;
  border-radius: 4px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: ${theme.spacing(3)};
  
  &:hover {
    background-color: #3b7b62; /* Slightly darker shade for hover effect */
  }
`;

// --- Footer Links and Checkbox ---

export const CheckboxGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${theme.spacing(2)};
  font-size: 0.9em;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  color: ${theme.colors.darkText};
  
  & input {
    margin-right: ${theme.spacing(1)};
  }
`;

export const LinkText = styled.a`
  color: ${theme.colors.link};
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const FooterLinkContainer = styled.div`
  margin-top: ${theme.spacing(3)};
  font-size: 0.9em;
`;

export const Separator = styled.span`
  color: ${theme.colors.darkText};
  margin: 0 ${theme.spacing(1)};
`;

export const ErrorText = styled.p`
  color: ${theme.colors.error};
  font-size: 0.9em;
  margin-top: ${theme.spacing(2)};
`;